import { useContext } from 'react';
import { TemplateBrowserContext } from '../../components/TemplateBrowserProvider';
export const useTemplateBrowserContext = () => {
    const ctx = useContext(TemplateBrowserContext);
    if (!ctx) {
        throw new Error('useTemplateBrowserContext must be used as a child to <TemplateBrowserProvider />');
    }
    return ctx;
};
